const data = {
    columnOneTitle: "Latest news",
    columnTwoTitle: "All the news",
    all: [{
        news: {
            time: "10/26/20",
            title: "Fibank signed an agreement with the Fund of Guaranteed Loans Funds with the possibility of providing an interest rate subsidy"
        },
        route: "/"
    },
    {
        news: {
            time: "10/07/20",
            title: "Agropodkrepa loan from Fibank in support of Bulgarian agriculture"
        },
        route: "/"
    },
    {
        news: {
            time: "08/18/20",
            title: "Fibank offers interest-free credit cards"
        },
        route: "/"
    }]
}

export default data;

